import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

export interface TrackingEvent {
	name: string;
	app: string;
	total_count: number;
	last_seen_at: string | null;
	deprecated_at: string | null;
	previous_names: string[];
}

export interface QueryOpts {
	enabled?: boolean;
}

const fetchEvents = async (
	includeDeprecated: boolean
): Promise<TrackingEvent[]> => {
	const { data } = await cmsClient.get<TrackingEvent[]>("/tracking/events/", {
		params: { include_deprecated: includeDeprecated }
	});
	return data;
};

const useTrackingEvents = (includeDeprecated = true, options?: QueryOpts) =>
	useQuery(
		["tracking", "events", String(includeDeprecated)],
		() => fetchEvents(includeDeprecated),
		options
	);

export default useTrackingEvents;
